import "./TestIcdCodesViewComponent.scss";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import {ITableColumn} from "../../../../../shared/models/table.model";
import TableV2Component from "../../../../../shared/components/table-components/table-v2/TableV2Component";

interface TestIcdCodesViewComponentProps {
    testDetails: any;
    onEditModeOpen: Function;
    canEdit: boolean;
}

const TestIcdCodesViewComponent = (props: TestIcdCodesViewComponentProps) => {
    const {
        testDetails,
        onEditModeOpen, canEdit
    } = props;

    console.log(testDetails)

    const columns: ITableColumn[] = [
        {
            id: "icdCode",
            label: "ICD Code",
            width: 100,
            isDefaultColumn: true, align: "center"
        },
        {
            id: "description",
            label: "Description",
            width: 300,
            isDefaultColumn: true, align: "left"
        },
    ]

    return (
        <div className={'test-icd-codes-view-component  details-tab-data-content'}>
            {testDetails && <>
                <div className="details-tab-data-header">
                    <div className="view-and-edit-title">All Linked ICD Code(s):</div>
                    {canEdit &&
                        <div className="">
                            <ButtonComponent
                                className={"white-space-nowrap"}
                                type="button"
                                color={"primary"}
                                variant={"outlined"}
                                startIcon={<EditIcon/>}
                                fullWidth={true}
                                handleClick={onEditModeOpen}
                            >
                                Edit Details
                            </ButtonComponent>
                        </div>
                    }
                </div>
                <div className="details-tab-data-body mrg-top-20">
                    <div className={'t-table-container'}>
                        <TableV2Component
                            columns={columns}
                            data={testDetails?.icdCodesDetails}
                        />
                    </div>
                </div>
            </>
            }
        </div>
    );

};

export default TestIcdCodesViewComponent;